import { memo } from 'react'

const TreeIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.35 21.5v-1.9h5.7v-3.8h-1.9c-1.314 0-2.434-.463-3.36-1.39-.926-.926-1.39-2.046-1.39-3.36 0-.95.261-1.825.784-2.624A4.526 4.526 0 0 1 7.298 6.68 4.609 4.609 0 0 1 8.854 3.7c.895-.8 1.943-1.2 3.146-1.2 1.203 0 2.252.4 3.147 1.2a4.605 4.605 0 0 1 1.556 2.98 4.519 4.519 0 0 1 2.113 1.746c.523.8.784 1.675.784 2.624 0 1.314-.463 2.434-1.39 3.361-.926.927-2.046 1.39-3.36 1.389h-1.9v3.8h5.7v1.9H5.35Zm3.8-7.6h5.7c.792 0 1.465-.277 2.019-.831a2.749 2.749 0 0 0 .831-2.019c0-.57-.162-1.093-.487-1.568a2.871 2.871 0 0 0-1.27-1.044l-.998-.428-.143-1.092a2.868 2.868 0 0 0-.937-1.794A2.676 2.676 0 0 0 12 4.4c-.713 0-1.335.242-1.865.725a2.864 2.864 0 0 0-.937 1.793L9.055 8.01l-.997.428c-.523.221-.946.57-1.27 1.044A2.727 2.727 0 0 0 6.3 11.05c0 .792.277 1.465.831 2.019a2.749 2.749 0 0 0 2.019.831Z"
    />
  </svg>
)

export default memo(TreeIcon)
